import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { exchangeCodeForToken } from "../api";
import { useAuth } from "../contexts/AuthContext";

const CallbackPage = () => {
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const { setIsAuthenticated } = useAuth();

  useEffect(() => {
    const handleCallback = async () => {
      const searchParams = new URLSearchParams(location.search);
      const code = searchParams.get("code");

      if (!code) {
        setError("No authorization code was received from Bitbucket");
        return;
      }

      try {
        await exchangeCodeForToken(code);
        setIsAuthenticated(true);
        navigate("/dashboard");
      } catch (err) {
        setError("Failed to authenticate with Bitbucket");
        console.error(err);
      }
    };

    handleCallback();
  }, [location, navigate, setIsAuthenticated]);

  if (error) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="text-destructive text-lg font-semibold">{error}</div>
      </div>
    );
  }

  return (
    <div className="flex justify-center items-center h-screen">
      <div className="w-6 h-6 border-2 border-primary border-t-transparent rounded-full animate-spin"></div>
      <span className="ml-2 text-lg">Authenticating with Bitbucket...</span>
    </div>
  );
};

export default CallbackPage;
